import React from "react";

export const Skeleton: React.FC<{ className?: string }> = ({ className = "" }) => (
  <div className={`animate-pulse rounded-md bg-slate-800/90 ${className}`} aria-hidden />
);

export const TableSkeletonRows: React.FC<{ rows?: number; cols?: number }> = ({ rows = 5, cols = 4 }) => (
  <div className="space-y-2">
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex gap-3">
        {Array.from({ length: cols }).map((_, c) => (
          <Skeleton key={c} className="h-10 flex-1" />
        ))}
      </div>
    ))}
  </div>
);

export const CardGridSkeleton: React.FC<{ cards?: number }> = ({ cards = 6 }) => (
  <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
    {Array.from({ length: cards }).map((_, i) => (
      <div key={i} className="rounded-xl border border-slate-800 bg-slate-900/60 p-5">
        <Skeleton className="mb-3 h-5 w-2/3" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="mt-2 h-3 w-5/6" />
      </div>
    ))}
  </div>
);

export const DetailPageSkeleton: React.FC = () => (
  <div className="space-y-6">
    <Skeleton className="h-32 w-full rounded-xl" />
    <Skeleton className="h-12 w-full max-w-md rounded-lg" />
    <Skeleton className="h-64 w-full rounded-xl" />
  </div>
);
